import type { ReactNode } from 'react';
import { Download, Loader2 } from 'lucide-react';

// A FILE TO TAKE AWAY, as one button everywhere (Louis 2026-10-29): a link where the file is an
// address (`href`), a button where it is made on the press (`onClick`); `busy` while it is.
// WITHIN ITS ROOM, on two rows where one does not fit (Louis 2026-10-29): "Création du fichier 3D…
// 100 % (arrêter)" ran past the column it stands in. rounded-2xl is a pill on one row, and still one
// on two.
const PILL = 'inline-flex max-w-full items-center gap-1.5 rounded-2xl border bg-white px-3 py-1.5 text-center text-xs font-semibold shadow-sm transition-colors';

export function DownloadPill({ href, onClick, busy = false, children }: {
  href?: string;
  onClick?: () => void;
  busy?: boolean;
  children: ReactNode;
}) {
  const look = `${PILL} ${busy ? 'border-red-400 text-red-600' : 'border-slate-300 text-slate-700 hover:border-blue-500 hover:text-blue-600'}`;
  const icon = busy ? <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin" /> : <Download className="h-3.5 w-3.5 shrink-0" />;
  if (href) return <a href={href} download className={look}>{icon}{children}</a>;
  return <button type="button" onClick={onClick} className={look}>{icon}{children}</button>;
}
